import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { About } from "./components/pages/About/About";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
